import * as Types from '../constants/actionTypes';
const defaultState = {
    usersList: [],
    selectedUserData: {},
    formattedUserClients: [],
    masterUserPaginationKeys: [],
    userCountriesList: []
}
export default (state = defaultState, action) => {
    switch (action.type) {
        case Types.SET_ROLES_DATA:
            return {
                ...state,
                rolesData: action.rolesData
            }
        case Types.SET_ROLE_IDS:
            return {
                ...state,
                roleIds: action.roleIds
            }
        case Types.SET_RIGHT_OBJECTS:
            return {
                ...state,
                rightObjects: action.rightObjects
            }
        case Types.SET_ROLE_RIGHTS:
            return {
                ...state,
                rights: action.rights
            }


        case Types.UPDATE_USER:
            return {
                ...state,
                user: action.user
            }
        case Types.SHOW_DATA:
            return {
                ...state,
                color: action.color
            }


        /* Admin users reducers */
        case Types.LIST_USER_DATA:
            return {
                ...state,
                usersList: action.usersList
            }
        case Types.LIST_ADMIN_USER_PAGE_COUNT: 
            return {
                ...state,
                userPageCount: action.pageCount
            }
        case Types.LIST_ADMIN_USERS_COUNT: 
            return {
                ...state,
                adminUsersCount: action.userCount
            }
        case Types.LIST_ADMIN_USERS_CONFIGURATIONS: 
            return {
                ...state,
                listUserConfigurations: action.data
            }
        case Types.LIST_ADMIN_USERS_CONFIGURATIONS_COUNT: 
            return {
                ...state,
                countAdminUserConfigurations: action.data
            }
        case Types.USERS_CLIENTS_DATA: 
            return {
                ...state,
                userClientsData: action.userClients.data
            }
        case Types.ALL_USER_ROLES_DATA: 
            return {
                ...state,
                allUserRoles: action.userRoles.data
            }
        case Types.ALL_PORTAL_DATA: 
            return {
                ...state,
                allPortalData: action.allPortals.data
            }

        case Types.USER_COUNTRIES_LIST: 
            return {
                ...state,
                userCountriesList: action.data
            }
        case Types.ADD_USER_COUNTRIES_LIST:            
            return { ...state, userCountriesList: [ ...state.userCountriesList, ...action.data ]}
        case Types.DELETED_USER_COUNTRIES:
            const userCountriesList = state.userCountriesList.filter(country => action.data.findIndex(i => i.countryId === country.countryId && i.userId === country.userId) === -1)    
            return { ...state, userCountriesList}
        case Types.USER_COUNTRIES_ERROR: 
            return {
                ...state,
                userCountryError: action.userCountryError
            }
        case Types.MASTER_USER_PAGE_LAST_EVALUATED_KEY: {
            let existKeys = state.masterUserPaginationKeys
            if(action.popClear) {
                
                if(existKeys && existKeys.length) {
                    existKeys.pop()
                }
                if(action.isPrevious && existKeys.length>1) {
                    existKeys.pop()
                }
             }
             if(action.LastEvaluatedKey) {
                 existKeys.push(action.LastEvaluatedKey)
             }
            return {
                ...state,
                masterUserPaginationKeys: existKeys
            }
        }
        case Types.DELETE_ADMIN_USERS:
            return {
                usersDelete:action.usersDelete
            }
        case Types.USERS_ERROR:
            return {
                ...state,
                userError: action.userError
            }
        case Types.NEW_ADDED_USER:
            state.usersList.push(action.addedUser)
            return {
                ...state
            }
        case Types.SELECTED_USER_DATA:
            if(action.updatedUserData) {
                let findDataIndex = state.usersList.findIndex((oneData)=> { return oneData && (oneData.userId === action.updatedUserData.userId)})
                if(findDataIndex > -1) {
                    state.usersList[findDataIndex] = action.updatedUserData
                }else  {
                    state.usersList.push(action.updatedUserData)
                }
                return {
                    ...state
                }
            } else {
                return {
                    ...state,
                    selectedUserData: action.selectedUserData
                }
            }
        // formatted user client
        case Types.USER_FORMATTED_CLIENTS:
            return {
                ...state,
                formattedUserClients: action.formattedUserClients
            }
        case Types.DELETE_FORMATTED_CLIENTS:
            state.formattedUserClients.splice(action.delFormatIndex)
            return {
                ...state
            }
        case Types.ADDED_NEW_FORMATTED_CLIENT:
            state.formattedUserClients.push(action.addedFormattedUserClient)
            return { ...state }
        case Types.USER_LOGS_INFO:
            state.userLogs = action.userLogs
            return { ...state }
        default:
            return state
    }

}

